import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 pt-16">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0 font-heading">
        404
      </h1>
      <div className="relative z-10">
        <span className="w-16 h-16 flex items-center justify-center mx-auto mb-4 text-foreground-300">
          <i className="ri-emotion-sad-line text-5xl"></i>
        </span>
        <h1 className="text-xl md:text-2xl font-heading font-semibold text-foreground-800 mt-6">页面未找到</h1>
        <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
        <Link
          to="/"
          className="inline-flex mt-6 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}